import { render, staticRenderFns } from "./DeclineForm.vue?vue&type=template&id=5c10dc54&"
import script from "./DeclineForm.vue?vue&type=script&lang=js&"
export * from "./DeclineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports